import React from 'react';
import {Image} from 'antd-mobile';
import {WinnerData} from './index.d';

export default function HotItem(props: {winner: WinnerData; style?: any}) {
  const {winner, style} = props;
  return (
    <div className={'flex items-center rounded-lg '} style={style ? style : {}}>
      <Image
        src={winner?.gameIcon}
        alt={winner?.gameName}
        className="w-10 h-10 rounded-md"
        fallback={<div className="size-12 bg-image rounded-md" />}
      />
      <div className="ml-3 flex-grow ">
        <div className="text-sm text-white font-bold">
          {winner?.gameName || ''}
        </div>
        <div className="h-[0.125rem]" />
        <div className="text-xs text-t2-dark font-weight-500">
          ID: {winner?.userName || winner?.userPhone}
        </div>
      </div>
      <div className="text-right">
        <div className="text-xs text-t2-dark font-weight-500">Bonus</div>
        <div className="h-[0.125rem]" />
        <div className="text-sm text-white font-bold">
          ₹{winner?.bonus ? winner?.bonus.toLocaleString('en-IN') : ''}
        </div>
      </div>
    </div>
  );
}
